import {dropdownOption} from '../../../shapes';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import DropdownScrollable from '../../../../DropdownScrollable/DropdownScrollable';
import BodySpecialAccordionHeaderOverflow from './BodySpecialAccordionHeaderOverflow';
import BodySpecialAccordionTrigger from './BodySpecialAccordionTrigger';

export const BodySpecialAccordionHeader = ({className, accordion, children, dropdownOptions}) => {
	const renderDropdown = () => {
		return (
			<>
				{dropdownOptions && dropdownOptions.length > 0 && (
					<DropdownScrollable>
						<BodySpecialAccordionHeaderOverflow config={dropdownOptions} setIsOpen={() => {}} />
					</DropdownScrollable>
				)}
			</>
		);
	};

	let render = children;

	if (accordion) {
		render = (
			<BodySpecialAccordionTrigger>
				{render}
				{renderDropdown()}
			</BodySpecialAccordionTrigger>
		);
	} else {
		render = (
			<StyledBodySpecialNonAccordionTrigger className="StyledBodySpecialNonAccordionTrigger">
				{render}
				{renderDropdown()}
			</StyledBodySpecialNonAccordionTrigger>
		);
	}

	return (
		<StyledBodySpecialAccordionHeader className={`StyledBodySpecialAccordionHeader ${className}`} accordion={accordion}>
			{render}
		</StyledBodySpecialAccordionHeader>
	);
};

BodySpecialAccordionHeader.propTypes = {
	className: PropTypes.string,
	accordion: PropTypes.bool,
	children: PropTypes.node,
	dropdownOptions: PropTypes.arrayOf(dropdownOption).isRequired
};

BodySpecialAccordionHeader.defaultProps = {
	className: 'body-special-accordion-header',
	accordion: true
};

export default BodySpecialAccordionHeader;

const StyledBodySpecialAccordionHeader = styled.section`
	display: flex;
	background: var(--neutrals-00white) !important;
	border-radius: var(--px-7);
	.motif-accordion-trigger {
		margin: 0;
		min-height: var(--px-85);
		gap: 0 !important;
	}
`;

const StyledBodySpecialNonAccordionTrigger = styled.section`
	display: flex;
	width: 100%;
	padding-left: var(--px-16);
	height: var(--px-74);
	font-size: var(--px-16);
	line-height: var(--px-20);
	background-color: var(--accordion-header--bg-color);
	border-radius: var(--px-7);
	padding-right: var(--px-14);
`;
